import { CREATE_ENDORSEMENT } from '../../constants/actions/policy';

export function createEndorsement(payload) {
    return {
        type: CREATE_ENDORSEMENT,
        payload,
    };
}
